document.addEventListener('DOMContentLoaded' , ( e ) => {
    loadCustomSliders( e , false );
});
document.addEventListener('shopify:section:load' , ( e ) => {
    loadCustomSliders( e , true );
});

window.addEventListener('resize' , ( e ) => {
    loadCustomSliders( e , true );
})

let flickityCustomImageSliders = [];

function loadCustomSliders( event ,  reinit = false ) {
    const sliders = document.querySelectorAll('.custom-image-slider-section');
    if ( reinit ) {
        flickityCustomImageSliders = [];
    }
    
    for ( let i = 0; i < sliders.length; i++ ) {
        if ( reinit ) {
            sliders[i].classList.remove('init');
        }

        if ( !sliders[i].classList.contains('init') ) {
            const target = sliders[i].querySelector('.slides-list-container');
            const maxSliderSize = sliders[i].getAttribute('data-layout-adjustment-width');

            if ( target != null ) {
                try {
                    const options = {
                        dragable: true,
                        contain: false,
                        freeScroll: true,
                        wrapAround: true,
                        accessibility: true,
                        prevNextButtons: false,
                        pageDots: true,
                        lazyLoad: false
                    };

                    const windowWidth = window.innerWidth;
                    const maxSliderSizeAsInt = parseInt( maxSliderSize );
                    if ( windowWidth < maxSliderSizeAsInt ) {
                        const flkty = new Flickity( target, options );
                        const slider = {
                            flkty: flkty,
                            max_width: maxSliderSizeAsInt
                        };
    
                        flickityCustomImageSliders.push( slider );
                        sliders[i].classList.add('init');
                    } else {
                        const flkty = new Flickity( target, options );
                        flkty.destroy();
                        sliders[i].classList.remove('init');
                    }
                } catch ( error ) {
                    console.log( 'FAILED TO INIT FLICKITY FOR ', target );
                    console.log( error );
                }
            }
        }
    }
}